import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Root } from './Snackbar.styles'

/**
 * The Snackbar' component.
 */
const Snackbar = forwardRef((props, ref) => {
  const { children, duration, open, originX, originY, onClose, ...restProps } = props

  return (
    <Root
      {...restProps}
      anchorOrigin={{ horizontal: originX, vertical: originY }}
      autoHideDuration={duration}
      open={open}
      ref={ref}
      onClose={onClose}
    >
      {children}
    </Root>
  )
})

Snackbar.defaultProps = {
  duration: 6000,
  open: false,
  originX: 'right',
  originY: 'top',
  onClose: () => undefined
}

Snackbar.propTypes = {
  /**
   * Children.
   */
  children: PropTypes.node.isRequired,
  /**
   * Duration.
   */
  duration: PropTypes.number,
  /**
   * Open.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Origin X.
   */
  originX: PropTypes.oneOf(['center', 'left', 'right']),
  /**
   * Origin Y.
   */
  originY: PropTypes.oneOf(['bottom', 'top']),
  /**
   * On close.
   */
  onClose: PropTypes.func
}

export default Snackbar
